var path = 'templates/personal.html';
var html = "<md-content flex=100 style=height:100% class=\"entries md-padding\"> <md-nav-bar md-selected-nav-item=selectedNavItem nav-bar-aria-label=\"navigation links\"> <md-nav-item md-nav-click=\"switchNavItem('fav-list')\" name=fav-list> お気に入り </md-nav-item> <md-nav-item md-nav-click=\"switchNavItem('history')\" name=history> 作業履歴 </md-nav-item> </md-nav-bar> <div class=md-padding ui-view></div> </md-content> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/personal.html
// module id = 52
// module chunks = 0